<template>
  <div style="font-size: 14px">
    <vs-row 
      v-for="(error, rowNum, index) in customFieldsErrors"
      :key="index"
      style="margin-top: 10px"
    >
      <vs-row style="margin-top: 10px">
        <p>Row {{ rowNum }}</p>
      </vs-row>
      <vs-row style="margin-left: 10px">
        <ul>
          <li v-for="(cfError, cfIndex) in error" :key="cfIndex">
            {{ cfError.msg }} 
          </li>
        </ul>
      </vs-row>
    </vs-row>
  </div>
</template>

<script>
export default {
  name: 'Errors',
  props: {
    customFieldsErrors: {
      type: Object,
      required: true
    }
  }
}
</script>
